<ng-container>
  <div *ngIf="myCasesHistory?.length == 0">
    <h3>Você ainda não possui nenhuma oportunidade registrada.</h3>
  </div>
  <div *ngIf="myCasesHistory?.length > 0">
    <app-table
      [items]="myCasesHistory"
      [totalRows]="totalRows"
      [loading]="loading"
      (pageChange)="paginationChange($event)"
    >
      <app-card-cases
        *ngFor="let case of myCasesHistory"
        [data]="case"
        [selectedTab]="2"
        (getCaseDetails)="showCaseDetails($event)"
      ></app-card-cases>
    </app-table>
  </div>
</ng-container>
